export type Language = 'en' | 'ru' | 'uz' | 'fa' | 'pt' | 'tr';

// WHY: lives here, not by the store: imported across the 'use client' boundary the map is a client reference and `dir`
// silently drops
export const LANGUAGE_DIR: Record<Language, 'ltr' | 'rtl'> = {
  en: 'ltr',
  ru: 'ltr',
  uz: 'ltr',
  fa: 'rtl',
  pt: 'ltr',
  tr: 'ltr',
};

export type TranslationsMap<T> = {
  en: T;
  ru: T;
  uz: T;
  fa: T;
  pt: T;
  tr: T;
};

export function createTranslations<T extends Record<string, string>>(
  translations: { en: T; ru: NoInfer<T>; uz: NoInfer<T>; fa: NoInfer<T>; pt: NoInfer<T>; tr: NoInfer<T> }
): TranslationsMap<T> {
  return translations;
}
